import React from "react";

export default function DataTable({ columns, data, emptyMessage = "No Data Available", onRowClick, footer }) {
    return (
        <div className="w-full overflow-auto  sm:border sm:rounded-xl sm:shadow-sm text-sm">
            <table className="w-full border-collapse bg-white">
                <thead className="sticky top-0 bg-white">
                    <tr className="h-10 border-b-black">
                        {columns.map((column) => (
                            column.visible !== false && 
                            <th
                                key={column.key}
                                className={column.headerClassName ?? "px-2 text-left font-semibold"}
                            >
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td
                                colSpan={columns.length}
                                className="h-[250px] text-center align-middle"
                            >
                                {emptyMessage}
                            </td>
                        </tr>
                    ) : (
                        data.map((row, index) => (
                        <tr
                            key={row.id ?? index}
                            className="h-10 border-y hover:bg-slate-100 cursor-pointer"
                            onClick={() => onRowClick?.(row)}
                        >
                            {columns.map((column) => (
                                column.visible !== false &&
                                <td
                                    key={column.key}
                                    className={
                                        column.cellClassName ?? 'px-2'
                                    }
                                >
                                    {column.render
                                    ? column.render(row, index)
                                    : row[column.key]}
                                </td>
                            ))}
                        </tr>
                        ))
                    )}
                </tbody>

                {footer && (
                    <tfoot className="sticky bottom-0 bg-white">
                        {footer}
                    </tfoot>
                )}
            </table>
        </div>
    );
}